export default "__VITE_ASSET__va52v_jH__"